import { createStore } from 'owa-satcheljs';

interface MyOutlookViewState {
    isFullPageShowing: boolean;
}

const getMyOutlookViewState: () => MyOutlookViewState = createStore<MyOutlookViewState>(
    'MyOutlookViewState',
    {
        isFullPageShowing: false,
    }
);

export default getMyOutlookViewState;
